import React from "react";
import { FormattedMessage, useIntl } from "react-intl";
import { Helmet } from "react-helmet";
import { Grid, PageWrapper } from "components/Containers";
import { SearchInput } from "components/Search";
import { NETWORK_LIST_BADGES_OPTIONS } from "constants/index";
import { Banner, BannerShowcaseSignup, BookMeetingMemberBanner } from "components/Banner";
import { TeamAddButton, TeamSummary } from "components/Teams";
import { useNetworkControls } from "hooks";
import { NetworkList, NetworkListControls } from "components/Network";
import Disclaimer from "components/Disclaimer";

/**
 * TeamBuilder
 */
const TeamBuilder = () => {
  const intl = useIntl();
  const resultsPerPage = 18;
  const { filterMetadata, data, ...rest } = useNetworkControls({
    resultsPerPage,
    initialValues: {
      filters: {
        badges: [NETWORK_LIST_BADGES_OPTIONS.featured],
      },
    },
  });

  return (
    <>
      <SearchInput onChange={rest?.handleSearchInputChange} initialValue={rest?.keyword}>
        <BannerShowcaseSignup />
      </SearchInput>
      <PageWrapper>
        <Helmet>
          <title>{intl.formatMessage({ id: "Meta.ClientSearch.Title" })}</title>
        </Helmet>
        <Banner keyName="showClientSearchBanner">
          <FormattedMessage
            id="Client.TeamBuilder.Banner.Title1"
            values={{
              intro: (
                <b>
                  <FormattedMessage id="Client.Search.Banner.Title2" />
                </b>
              ),
            }}
          />
        </Banner>
        <Grid topMargin>
          <Grid.col start={1} end={13}>
            <TeamSummary />
          </Grid.col>
          <Grid.col start={1} end={13}>
            <NetworkListControls formValues={filterMetadata} hideKeywordSearch hideSorts {...rest} />
          </Grid.col>
          <Grid.col start={1} end={13}>
            <NetworkList
              data={data}
              profileModalActions={[TeamAddButton]}
              actions={[TeamAddButton]}
              isCardView={true}
              {...rest}
            />
          </Grid.col>
          <Grid.col start={1} end={13}>
            <BookMeetingMemberBanner />
          </Grid.col>
          <Grid.col start={1} end={13}>
            <Disclaimer />
          </Grid.col>
        </Grid>
      </PageWrapper>
    </>
  );
};

export default TeamBuilder;
